import { Language } from "../utils/dictionary";
import { dictionary } from "../utils/dictionary";

export const getCountriesList = (language: Language = Language.SPANISH) => {
  const allowed = [
    // "argentina",
    // "bolivia",
    // "brazil",
    // "canada",
    // "chile",
    "colombia",
    // "ecuador",
    // "mexico",
    // "paraguay",
    // "peru",
    // "united-states",
    // "uruguay",
    // "venezuela",
  ];

  const allCountries = [
    {
      name: dictionary["argentina"][language],
      flag: "🇦🇷",
      currency: "ARS",
      language: "es",
      country: "AR",
    },
    {
      name: dictionary["bolivia"][language],
      flag: "🇧🇴",
      currency: "BOB",
      language: "es",
      country: "BO",
    },
    {
      name: dictionary["brazil"][language],
      flag: "🇧🇷",
      currency: "BRL",
      language: "pt",
      country: "BR",
    },
    {
      name: dictionary["canada"][language],
      flag: "🇨🇦",
      currency: "CAD",
      language: "en",
      country: "CA",
    },
    {
      name: dictionary["chile"][language],
      flag: "🇨🇱",
      currency: "CLP",
      language: "es",
      country: "CL",
    },
    {
      name: dictionary["colombia"][language],
      flag: "🇨🇴",
      currency: "COP",
      language: "es",
      country: "CO",
    },
    {
      name: dictionary["ecuador"][language],
      flag: "🇪🇨",
      currency: "USD",
      language: "es",
      country: "EC",
    },
    {
      name: dictionary["mexico"][language],
      flag: "🇲🇽",
      currency: "MXN",
      language: "es",
      country: "MX",
    },
    {
      name: dictionary["paraguay"][language],
      flag: "🇵🇾",
      currency: "PYG",
      language: "es",
      country: "PY",
    },
    {
      name: dictionary["peru"][language],
      flag: "🇵🇪",
      currency: "PEN",
      language: "es",
      country: "PE",
    },
    {
      name: dictionary["united-states"][language],
      flag: "🇺🇸",
      currency: "USD",
      language: "en",
      country: "US",
    },
    {
      name: dictionary["uruguay"][language],
      flag: "🇺🇾",
      currency: "UYU",
      language: "es",
      country: "UY",
    },
    {
      name: dictionary["venezuela"][language],
      flag: "🇻🇪",
      currency: "VES",
      language: "es",
      country: "VE",
    },
  ];

  return allCountries
    .filter((c) =>
      allowed.includes(
        Object.keys(dictionary).find(
          (key) => dictionary[key][language] === c.name
        ) || ""
      )
    )
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const getLanguagesList = (language: Language = Language.SPANISH) => [
  { name: dictionary["spanish"][language], code: "es" },
  { name: dictionary["english"][language], code: "en" },
  { name: dictionary["portuguese"][language], code: "pt" },
];
